











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamsLimitExceededNotification_notification",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationTemplate_notification"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgPicture",
      "storageKey": null
    }
  ],
  "type": "NotifyTeamsLimitExceeded",
  "abstractKey": null
};

(node ).hash = "ad294296a81b1d204209714c0bbe37ce";

export default node;
